import { v2Request } from './client';

/**
 * @param {string} mobile - Pilot user doc id (10-digit mobile)
 * @returns {Promise<Array<Record<string, unknown>>>}
 */
export async function getPilotUserAddresses(mobile) {
  const data = await v2Request(`/api/users/${encodeURIComponent(mobile)}/addresses`);
  return Array.isArray(data.addresses) ? data.addresses : [];
}

/**
 * @param {string} mobile
 * @param {{ userName: string, houseDetails: string, streetDetails?: string, landmark?: string, pincode: string, latLong: { lat: number, lng: number } }} body
 */
export async function addPilotUserAddress(mobile, body) {
  const data = await v2Request(`/api/users/${encodeURIComponent(mobile)}/addresses`, {
    method: 'POST',
    body,
  });
  return data.address;
}
